// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalAdditionalContent_root__gRc8c","placeHolderShimmer":"MultipleModalAdditionalContent_placeHolderShimmer__HxEmI"};